import { useMemo } from "react";
import type { NavigateOptions, To } from "react-router";
import { useNavigate } from "react-router";

import { hardNavigate } from "common/utilities/hardNavigate";

/**
 * Wraps `useNavigate` for backwards-compatible navigation.
 *
 * @returns A `go` function for navigation.
 */
export const useGo = () => {
  const navigate = useNavigate();

  return useMemo(
    () => (to: To, options?: NavigateOptions) => {
      if (typeof to === "object" || !to.startsWith("http")) return void navigate(to, options);
      if (!to.startsWith(import.meta.env.VITE_WEBSITE_URL)) {
        hardNavigate(to);
        return;
      }
      const url = new URL(to);
      return void navigate(`${url.pathname}${url.search}${url.hash}`, options);
    },
    [navigate],
  );
};
